import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { LanguageNameSpaces } from "@shared/types";
import common from "@shared/common/i18n/locales/en/common.json";
import auth from "@shared/common/i18n/locales/en/auth.json";
import dashboard from "@shared/common/i18n/locales/en/dashboard.json";
import trades from "@shared/common/i18n/locales/en/trades.json";
import affiliation from "@shared/common/i18n/locales/en/affiliation.json";
import settings from "@shared/common/i18n/locales/en/settings.json";
import groups from "@shared/common/i18n/locales/en/groups.json";
import watchlist from "@shared/common/i18n/locales/en/watchlist.json";
import marketplace from "@shared/common/i18n/locales/en/marketplace.json";
import billing from "@shared/common/i18n/locales/en/billing.json";
import tradingTerminal from "@shared/common/i18n/locales/en/tradingTerminal.json";
import bots from "@shared/common/i18n/locales/en/bots.json";
import signals from "@shared/common/i18n/locales/en/signals.json";
import admin from "@shared/common/i18n/locales/en/admin.json";
import onboarding from "@shared/common/i18n/locales/en/onboarding.json";
import portfolio from "@shared/common/i18n/locales/en/portfolio.json";
import payouts from "@shared/common/i18n/locales/en/payouts.json";
import assetManager from "@shared/common/i18n/locales/en/assetManager.json";
import usersManagement from "@shared/common/i18n/locales/en/usersManagement.json";
import { SUPPORTED_LANGUAGES } from "utils/language.ts";
import dayjs from "dayjs";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/ru";
import "dayjs/locale/zh-cn";
import { getDateLocale } from "@shared/common/i18n/dateLocales";

i18n.on("languageChanged", (language) => {
  document.documentElement.lang = language;
  dayjs.locale(getDateLocale(language));
});

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    detection: {
      order: ["localStorage"],
    },
    ns: [LanguageNameSpaces.COMMON],
    defaultNS: LanguageNameSpaces.COMMON,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    react: { useSuspense: true },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    partialBundledLanguages: true,
    resources: {
      en: {
        common,
        auth,
        dashboard,
        trades,
        affiliation,
        settings,
        groups,
        watchlist,
        marketplace,
        billing,
        tradingTerminal,
        bots,
        signals,
        admin,
        onboarding,
        portfolio,
        payouts,
        assetManager,
        usersManagement,
      },
    },
  });
